export default "__VITE_ASSET__7be6e660__"